/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LogResponse = {
    properties: {
        logs: {
            type: 'array',
            contains: {
                type: 'LogEntry',
            },
            isRequired: true,
        },
        page: {
            type: 'number',
            isRequired: true,
        },
        page_size: {
            type: 'number',
            isRequired: true,
        },
        total_count: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
